import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { injectIntl, defineMessages  } from 'react-intl';
import '../App.css';

const messages = defineMessages({
    description: {
      id: 'Loading.description',
    },
  });

class LoadingControl extends Component {
  
    render() {
      return (
          <div><Spin size={this.props.size !== undefined ? this.props.size : "large"} tip={ this.props.intl.formatMessage(messages.description) }/></div>
    );
  }
}

const propTypes = {
    intl: PropTypes.object.isRequired,
  };
  LoadingControl.propTypes = propTypes;
  
  export default injectIntl(LoadingControl, {
    withRef: true,
  });